import React from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  Labeled,
  ReferenceField,
  ShowProps,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { getMonth, GetParam } from "utils/tools";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "../../components/SanitizedGrid";
import CustomPriceField from "../../components/CustomPriceField";
import ShowWrapper from "components/ShowWrapper";

const useStyles = makeStyles({
  remarkCellStyle: {
    minWidth: "500px",
  },
  routeNameCellStyle: {
    minWidth: "100px",
    maxWidth: "200px",
  },
});

const SubcontractorErpShow = (props: ShowProps) => {
  const classes = useStyles();
  const param = GetParam();
  const breadcrumb = [
    {
      title: "Subcontractors",
      link: `/subcontractors/${param.get("subcontractorId")}/show`,
    },
    {
      title: "Financial",
      link: `/subcontractors/${param.get("subcontractorId")}/show/2`,
    },
    {
      title: props.id,
      link: "",
    },
  ];

  return (
    <ShowWrapper
      breadcrumb={breadcrumb}
      actions={null}
      isDefaultTitle
      {...props}
    >
      <SimpleShowLayout>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">General Info</Typography>
          </Grid>

          <Grid item xs={3}>
            <Labeled source="Subcontractor">
              <ReferenceField
                source="subcontractorId"
                reference="subcontractors"
                linkType={false}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item xs={3}>
            <Labeled source="School">
              <ReferenceField
                source="schoolId"
                reference="schools"
                linkType={false}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item xs={3}>
            <Labeled label="ERP Period">
              <FunctionField
                render={(record: any) => (
                  <Typography variant="body2">
                    {getMonth(record.month)} - {record.year}
                  </Typography>
                )}
              />
            </Labeled>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item xs={12}>
            <Typography variant="h6">ERP Charge Table</Typography>
          </Grid>

          <Grid item xs={12}>
            <FunctionField
              render={(record: any) => {
                const sortedSubcontractorErpItems = record.subcontractorErpItems
                  ? record.subcontractorErpItems.sort((a: any, b: any) =>
                      a.routeName.localeCompare(b.routeName),
                    )
                  : [];

                return (
                  <SanitizedGrid container spacing={2}>
                    {sortedSubcontractorErpItems.length > 0 ? (
                      <Grid item xs={8}>
                        <ArrayField
                          source="subcontractorErpItems"
                          record={{
                            ...record,
                            subcontractorErpItems: sortedSubcontractorErpItems,
                          }}
                        >
                          <Datagrid>
                            <TextField
                              label="Route Name"
                              source="routeName"
                              cellClassName={classes.routeNameCellStyle}
                            />
                            <CustomPriceField source="amount" />
                            <TextField
                              label="Remark"
                              source="remark"
                              cellClassName={classes.remarkCellStyle}
                            />
                          </Datagrid>
                        </ArrayField>
                      </Grid>
                    ) : (
                      <Grid item xs={12}>
                        <Typography variant="body1">
                          Subcontractor ERP Items is Empty.
                        </Typography>
                      </Grid>
                    )}
                  </SanitizedGrid>
                );
              }}
            />
          </Grid>
        </SanitizedGrid>
      </SimpleShowLayout>
    </ShowWrapper>
  );
};

export default SubcontractorErpShow;
